import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const [status, setStatus] = useState<'checking' | 'ok' | 'no'>('checking');

  useEffect(() => {
    fetch('/api/parent/summary', { method: 'GET' })
      .then((r) => setStatus(r.ok ? 'ok' : 'no'))
      .catch(() => setStatus('no'));
  }, []);

  if (status === 'checking') {
    return (
      <div className="max-w-sm mx-auto px-5 pt-20 text-center text-ink/60">
        Checking…
      </div>
    );
  }
  if (status === 'no') return <Navigate to="/parent/login" replace />;
  return <>{children}</>;
}
